export default __webpack_public_path__ + "static/media/Snow_White_Noon.fe73d194.wav";